import * as React from 'react';

function scriptOtAutoBlock(_a) {
    var uuidDomain = _a.uuidDomain, onLoad = _a.onLoad;
    var attrs = {
        type: 'text/javascript',
        src: "https://cdn.cookielaw.org/consent/" + uuidDomain + "/OtAutoBlock.js",
    };
    var dataset = {};
    return createScript(attrs, dataset, onLoad);
}
function scriptOtSDKStub(_a) {
    var uuidDomain = _a.uuidDomain, onLoad = _a.onLoad;
    var attrs = {
        type: 'text/javascript',
        charset: 'utf-8',
        src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
    };
    var dataset = {
        domainScript: uuidDomain,
    };
    return createScript(attrs, dataset, onLoad);
}
function registerOptanonWrapperFunction() {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    function OptanonWrapper() { }
    window['OptanonWrapper'] = OptanonWrapper;
}
function createScript(attrs, dataset, onLoad) {
    var script = document.createElement('script');
    script.onload = function () {
        onLoad === null || onLoad === void 0 ? void 0 : onLoad();
    };
    for (var _i = 0, _a = Object.entries(attrs); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        script[key] = value;
    }
    script.dataset.sebraeCookieConsent = 'injected';
    for (var _c = 0, _d = Object.entries(dataset); _c < _d.length; _c++) {
        var _e = _d[_c], key = _e[0], value = _e[1];
        script.dataset[key] = value;
    }
    return script;
}
function append(element) {
    (document.head || document.body).appendChild(element);
}
function appended() {
    return !!document.querySelector('[data-sebrae-cookie-consent="injected"]');
}
function useCookieConsentInjection(uuidDomain, uuidCustomer) {
    var _a = React.useState(false), injected = _a[0], setInjected = _a[1];
    var _b = React.useState(false), autoBlockLoaded = _b[0], setAutoBlockeLoaded = _b[1];
    var _c = React.useState(false), SDKStubLoaded = _c[0], setSDKStubLoaded = _c[1];
    React.useEffect(function () {
        if (injected || !uuidDomain) {
            return;
        }
        if (appended()) {
            setInjected(true);
            return;
        }
        append(scriptOtAutoBlock({
            uuidDomain: uuidDomain,
            onLoad: function () {
                setAutoBlockeLoaded(true);
            },
        }));
        append(scriptOtSDKStub({
            uuidDomain: uuidDomain,
            onLoad: function () {
                setSDKStubLoaded(true);
            },
        }));
        registerOptanonWrapperFunction();
    }, [injected, uuidDomain]);
    React.useEffect(function () {
    }, [injected, uuidCustomer]);
    React.useEffect(function () {
        if (SDKStubLoaded && autoBlockLoaded) {
            setInjected(true);
        }
    }, [SDKStubLoaded, autoBlockLoaded]);
    return { injected: injected };
}

var SebraeCookieConsent = function (_a) {
    var _b = _a.uuidApp, uuidApp = _b === void 0 ? '' : _b, _c = _a.uuidUser, uuidUser = _c === void 0 ? '' : _c, _d = _a.debug, debug = _d === void 0 ? false : _d;
    var uuidDomain = React.useMemo(function () { return uuidApp !== null && uuidApp !== void 0 ? uuidApp : ''; }, [uuidApp]);
    var uuidCustomer = React.useMemo(function () { return uuidUser !== null && uuidUser !== void 0 ? uuidUser : ''; }, [uuidUser]);
    var injected = useCookieConsentInjection(uuidDomain, uuidCustomer).injected;
    React.useEffect(function () {
        if (debug) {
            if (uuidApp) {
                if (!injected) {
                    return console.log('[Sebrae Cookie Consent :: %s] Não injetou as depenências ainda para registrar a aplicação', uuidApp);
                }
                console.log('[Sebrae Cookie Consent :: %s] Opa! Já injetou as depenências', uuidApp);
                if (!uuidUser) {
                    return console.log('[Sebrae Cookie Consent :: %s] Sem usuário para registrar', uuidApp);
                }
                return console.log('[Sebrae Cookie Consent :: %s] Registrando o usuário: %s', uuidApp, uuidUser);
            }
            console.log('[Sebrae Cookie Consent] Sem UUID da aplicação');
        }
    }, [debug, uuidApp, uuidUser, injected]);
    return React.createElement(React.Fragment, null);
};

export { SebraeCookieConsent };
//# sourceMappingURL=index.es.js.map
